import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withStyles } from "@material-ui/styles";
import { I18n } from "@aws-amplify/core";
import { get, size, map, filter, includes } from "lodash";

import Grid from "@material-ui/core/Grid";

import TagColor from "../../Common/TagColor";
import Picture from "../../Common/Picture";
import EllipsedTextNew from "../../Common/EllipsedTextNew";
import HighlightedText from "../../Common/HighlightedText";

import {
  //getAttributeName,
  getAttributeValue,
  getAttributeValues,
  getProfileImage,
} from "../../../utils/profile";

import colors from "../../../assets/style/colors";
import images from "../../../assets/img/images";
import { formatPhone } from "../../../utils/form";
//import { displayColon } from "../../../utils/data";

const styles = {
  viewLink: {
    color: colors.primary,
    cursor: "pointer",
    fontSize: "0.86em",
  },
  checkmarkContainer: {
    color: colors.black54,
    minWidth: "30px",
    textAlign: "center",
    fontSize: "1.7em",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
};

const ProfileMatch = (props) => {
  const { classes, profile, lov, searchValue, language } = props;
  const [displayedValues, setDisplayedValues] = React.useState([]);
  const [displayedNb, setDisplayedNb] = React.useState(3);

  React.useEffect(() => {
    let values = [];
    let lpr = getAttributeValue(profile, 44);
    if (lpr) {
      values.push({ value: lpr, type: "LPR" });
    }
    getAttributeValues(profile, 50).forEach((ocr) => {
      let item = { ...ocr };
      item.type = getAttributeValue(ocr, 135, lov);
      if (includes(ocr.value, searchValue)) {
        item.matched = true;
        values = [item, ...values];
      } else {
        values.push(item);
      }
    });
    setDisplayedValues(values);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [lov]);

  const profileImage = getProfileImage(profile, props.allowAnyImage);

  return (
    <Grid
      item
      xs
      style={{
        padding: "10px",
        borderRadius: "2px",
        //border: `1px solid ${colors.black542}`,
        backgroundColor: colors.lightGrey,
        ...props.style,
      }}
      className={props.className}
      onClick={props.onClick}
    >
      <Grid container direction="column">
        <Grid item style={{ marginBottom: "5px" }}>
          <Grid container>
            <Grid item className="bold-500 text-87">
              {get(profile, ["type", "id"]) === 1 && get(profile, ["firstname"])
                ? `${get(profile, ["firstname"])} ${get(profile, ["lastname"])}`
                : get(profile, ["name"]) || I18n.get("site_unknown")}
            </Grid>
            <Grid
              item
              style={{
                marginLeft: "20px",
                maxHeight: "20px",
                overflow: "hidden",
              }}
            >
              <TagColor
                color={
                  get(profile, ["tag", "color", "code"])
                    ? `#${profile.tag.color.code}`
                    : get(profile, ["tag", "color_rgb"])
                    ? `#${profile.tag.color_rgb}`
                    : "undefined"
                }
                name={get(profile, ["tag", `name_${language}`])}
              />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          <Grid container wrap="nowrap">
            <Grid
              item
              style={{
                width: "72px",
                minWidth: "72px",
                height: "72px",
                border: `1px solid ${colors.veryLighPink}`,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: !profileImage ? colors.mediumGrey : "",
              }}
            >
              {profileImage ||
              !includes([1, 2, 3, 4], get(profile, ["type", "id"])) ? (
                <Picture
                  url={profileImage}
                  alt="profile_picture"
                  maxHeight={70}
                  style={{ maxWidth: "70px", maxHeight: "70px" }}
                />
              ) : (
                <img
                  src={
                    get(profile, ["type", "id"]) === 1
                      ? images.humanIconBlack
                      : get(profile, ["type", "id"]) === 2
                      ? images.truckIconBlack
                      : get(profile, ["type", "id"]) === 3
                      ? images.trailerIconBlack
                      : get(profile, ["type", "id"]) === 4
                      ? images.containerIconBlack
                      : null
                  }
                  width="50px"
                  alt="human"
                />
              )}
            </Grid>
            <Grid item>
              <Grid container direction="column" wrap="nowrap">
                {get(profile, ["type", "id"]) === 1 ? (
                  <>
                    {getAttributeValue(profile, 34) && (
                      <Grid
                        item
                        style={{ paddingLeft: "5px", display: "flex" }}
                      >
                        {/* <span
                          className="text-87 bold-500"
                          style={{ paddingRight: "5px" }}
                        >
                          {getAttributeName(profile, 34, language)}
                          {displayColon(language)}
                        </span> */}
                        <img src={images.phoneIcon} alt="phone" />
                        <span
                          className="text-54"
                          style={{
                            overflowWrap: "anywhere",
                            paddingLeft: "5px",
                          }}
                        >
                          {formatPhone(getAttributeValue(profile, 34))}
                        </span>
                      </Grid>
                    )}
                    {getAttributeValue(profile, 33) && (
                      <Grid
                        item
                        style={{ paddingLeft: "5px", display: "flex" }}
                      >
                        {/* <span
                          className="text-87 bold-500"
                          style={{ paddingRight: "5px" }}
                        >
                          {getAttributeName(profile, 33, language)}
                          {displayColon(language)}
                        </span> */}
                        <img
                          src={images.emailIcon}
                          alt="email"
                          style={{ paddingRight: "5px" }}
                        />
                        <EllipsedTextNew
                          text={getAttributeValue(profile, 33)}
                          maxWidth={210}
                          color={colors.black54}
                        />
                      </Grid>
                    )}
                  </>
                ) : (
                  map(
                    filter(
                      displayedValues,
                      (item, index) => index < displayedNb
                    ),
                    (item, index) => (
                      <Grid
                        item
                        key={index}
                        className="flexCenter"
                        style={{ marginLeft: "4px", marginBottom: "5px" }}
                      >
                        <Grid container alignItems="center">
                          <Grid item className={classes.checkmarkContainer}>
                            {item.mandatory_match && (
                              <img src={images.checkmarkGrey} alt="checkmark" />
                            )}
                          </Grid>
                          <Grid item>
                            <HighlightedText
                              text={get(item, ["value"])}
                              highlightText={searchValue}
                            />
                          </Grid>
                          {item.value && (
                            <Grid
                              item
                              className="text-54 text-italic"
                              style={{ marginLeft: "4px" }}
                            >
                              {`(
                            ${get(item, ["id"]) === 50 ? "OCR" : "LPR"}
                            ${
                              !includes(["LPR", ""], get(item, ["type"]))
                                ? ` - ${item.type}`
                                : ""
                            }
                          )`}
                            </Grid>
                          )}
                        </Grid>
                      </Grid>
                    )
                  )
                )}
                {size(displayedValues) > 3 && (
                  <Grid item style={{ paddingLeft: "40px" }}>
                    <span
                      className={classes.viewLink}
                      onClick={() =>
                        setDisplayedNb(
                          displayedNb === size(displayedValues)
                            ? 3
                            : size(displayedValues)
                        )
                      }
                    >
                      {displayedNb === size(displayedValues)
                        ? I18n.get("site_viewLess")
                        : I18n.get("site_viewMore")}
                    </span>
                  </Grid>
                )}
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
};

ProfileMatch.propTypes = {
  profile: PropTypes.object,
  lov: PropTypes.object,
  searchValue: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    language: state.user.language,
  };
};

export default connect(mapStateToProps)(withStyles(styles)(ProfileMatch));
